// extracted by mini-css-extract-plugin
export var pillWrapper = "_jf-0";
export var showOverflow = "_jf-1";